export default __webpack_public_path__ + "assets/icons/landing.571c11c9.svg";